import { computed, reactive, ref, watch } from '@nuxtjs/composition-api'
import mobileBroadbandSubscriptionFlowHandler from '~/composable/checkout/handler/mobileBroadbandSubscriptionFlowHandler';
import { STEP_TYPE } from '~/constants/StepType';
import useCustomerInfo from '~/composable/checkout/useCustomerInfo';
import { SIM_CARD_TYPE, SECRET_NUMBER_TYPE, CUSTOMER_SUBSCRIPTION_TYPE } from '~/constants/CheckoutFlow';
import useConfirmationInfo from '~/composable/checkout/useConfirmationInfo';
import usePaymentInfo from '~/composable/checkout/usePaymentInfo';
import useTlmCart from '~/composable/useTlmCart'

// checkout flow context for Mobile Broadband Subscriptions
export default (appContext) => {
  const { isSubscriptionOnly } = useTlmCart(appContext)
  const subscription = (() => {
    const menu = ref(CUSTOMER_SUBSCRIPTION_TYPE.NEW_NUMBER)
    return { menu }
  })()
  // panel 2 - set Future activation date
  const subscriptionInfo = (() => {
    const menu = ref(null)
    const startDate = reactive({
      futureActivationDate: '',
      selectedDate: ''
    })

    return {
      menu,
      startDate
    }
  })()
  const mobileNumber = ref(null)
  const mobileNumberId = ref(null)
  const numberInfo = computed(() => {
    const futureActivationDate = subscriptionInfo.menu.value === 'noDate' ? null : subscriptionInfo.startDate.futureActivationDate
    return {
      mobileNumber: mobileNumber.value,
      mobileNumberId: mobileNumberId.value,
      mbb: true,
      np: false,
      simcardType: SIM_CARD_TYPE.PHYSICAL_SIM,
      secretNumber: true,
      secretInfoType: SECRET_NUMBER_TYPE.SECRET_ALL,
      futureActivationDate
    }
  })
  const panels = reactive([
    {
      stepType: STEP_TYPE.CUSTOMER_INFO,
      heading: 'Kundeforhold',
      component: 'tlm-checkout-customer-info',
      componentDone: 'tlm-checkout-customer-type-done',
      contextName: 'customerRelation'
    },
    {
      stepType: STEP_TYPE.SUBSCRIPTION_TYPE,
      heading: 'Start dato',
      component: 'tlm-checkout-mobile-broadband-subscription-info',
      componentDone: 'tlm-checkout-mobile-broadband-subscription-info-done',
      hasNextButton: false
    },
    {
      stepType: STEP_TYPE.CUSTOMER_INFO_CONFIRMATION,
      heading: 'Kontakt og levering',
      component: 'tlm-checkout-customer-confirmation-type',
      componentDone: 'tlm-checkout-customer-info-done',
      hasNextButton: false
    },
    {
      stepType: STEP_TYPE.CONFIRMATION,
      heading: 'Opsummering',
      component: 'tlm-checkout-confirmation',
      componentDone: 'tlm-checkout-confirmation-done',
      validationComponent: 'tlm-checkout-step-validators-stock-validation',
      hasNextButton: false
    },
    {
      stepType: STEP_TYPE.PAYMENT,
      heading: 'Betaling',
      component: 'payment-container',
      hasNextButton: false
    }
  ])

  // MBB: SIM-only keeps old heading; router/modem uses "Kontakt og levering"
  watch(isSubscriptionOnly, (simOnly) => {
    const stepIdx = panels.findIndex(p => p.stepType === STEP_TYPE.CUSTOMER_INFO_CONFIRMATION)
    if (stepIdx === -1) {
      return
    }
    panels[stepIdx].heading = simOnly ? 'Kundeoplysninger' : 'Kontakt og levering'
  }, { immediate: true })
  let flowHandler = null;
  flowHandler = mobileBroadbandSubscriptionFlowHandler();
  const { payment } = usePaymentInfo()
  const { confirmation } = useConfirmationInfo()
  return {
    subscription,
    subscriptionInfo,
    numberInfo,
    mobileNumber,
    mobileNumberId,
    flowHandler,
    panels,
    customerInfo: useCustomerInfo(appContext),
    confirmation,
    payment
  }
}
